var settings = {
    "www.reiseland-brandenburg.de": {
        root: 1,
        ajaxRenderPage: 1568,
        resourcesBaseUrl: 'https://static.reiseland-brandenburg.de'
    },
    "test.reiseland-brandenburg.de": {
        root: 1,
        ajaxRenderPage: 1568,
        resourcesBaseUrl: 'https://test.reiseland-brandenburg.de',
        apiEndpoint: 'https://api.tmb.pixelpoint.biz/api/'
    },
    "live.reiseland-brandenburg.de": {
        root: 1,
        ajaxRenderPage: 1568,
        resourcesBaseUrl: 'https://static.reiseland-brandenburg.de'
    },
    "dev.tib.pixelpoint.biz": {
        root: 2437,
        ajaxRenderPage: 2485,//2477,
        resourcesBaseUrl: 'https://test.reiseland-brandenburg.de'
    },
    "en.tib.pixelpoint.biz": {
        root: 2437,
        ajaxRenderPage: 2485,//2477,
        resourcesBaseUrl: 'https://test.reiseland-brandenburg.de'
    },
    "live.tib.pixelpoint.biz": {
        root: 2437,
        ajaxRenderPage: 2485,
        resourcesBaseUrl: 'https://static.reiseland-brandenburg.de'
    },
    "www.tagen-in-brandenburg.de": {
        root: 2437,
        ajaxRenderPage: 2485,
        resourcesBaseUrl: 'https://static.reiseland-brandenburg.de'
    },
    "test.tagen-in-brandenburg.de": {
        root: 2437,
        ajaxRenderPage: 2485,
        resourcesBaseUrl: 'https://static.reiseland-brandenburg.de',
        apiEndpoint: 'https://api.tmb.pixelpoint.biz/api/'
    },
    "www.mice-brandenburg.com": {
        root: 2437,
        ajaxRenderPage: 2485,
        resourcesBaseUrl: 'https://static.reiseland-brandenburg.de'
    },
    "test.mice-brandenburg.com": {
        root: 2437,
        ajaxRenderPage: 2485,
        resourcesBaseUrl: 'https://static.reiseland-brandenburg.de',
        apiEndpoint: 'https://api.tmb.pixelpoint.biz/api/'
    },
    "dev-test.reiseland-brandenburg.de": {
        root: 2661,
        ajaxRenderPage: 2712,
        resourcesBaseUrl: 'https://test.reiseland-brandenburg.de',
        mapUrl: 'https://maps-ds.reiseland-brandenburg.de/',//'https://maps.dahme-seenland.de/',
        assetFolder: 'dahme-seen/'
    },
    "dev-ds.reiseland-brandenburg.de": { //www.dahme-seen.de
        root: 2661,
        ajaxRenderPage: 2712,
        resourcesBaseUrl: 'https://static.reiseland-brandenburg.de',//'https://test.reiseland-brandenburg.de',
        mapUrl: 'https://maps-ds.reiseland-brandenburg.de/',//'https://maps.dahme-seenland.de/',
        assetFolder: 'dahme-seen/'
    },
    "www.dahme-seenland.de": { //www.dahme-seen.de
        root: 2661,
        ajaxRenderPage: 2712,
        resourcesBaseUrl: 'https://static.reiseland-brandenburg.de',//
        mapUrl: 'https://maps.dahme-seenland.de/',
        //globalMapUrl: 'https://www.dahme-seenland.de/karte/',
        assetFolder: 'dahme-seen/'
    },
    "test.dahme-seenland.de": { //www.dahme-seen.de
        root: 2661,
        ajaxRenderPage: 2712,
        resourcesBaseUrl: 'https://static.reiseland-brandenburg.de',//
        mapUrl: 'https://maps.dahme-seenland.de/',
        //globalMapUrl: 'https://www.dahme-seenland.de/karte/',
        assetFolder: 'dahme-seen/',
        apiEndpoint: 'https://api.tmb.pixelpoint.biz/api/'
    },
    "test-flaeming.reiseland-brandenburg.de": {
        root: 2877,
        ajaxRenderPage: 2886,
        resourcesBaseUrl: 'https://maps-flaeming.reiseland-brandenburg.de/',
        mapUrl: 'https://maps-flaeming.reiseland-brandenburg.de/',
        assetFolder: 'flaeming/',
        region:12,
        regionOnMap: 200
    },
    "live-tourism.reiseland-brandenburg.de": { //www.dahme-seen.de
        root: 2947,
        ajaxRenderPage: 3067,
        resourcesBaseUrl: 'https://static.reiseland-brandenburg.de',
        mapUrl: 'https://www.reiseland-brandenburg.de/karte/',
        //globalMapUrl: 'https://www.reiseland-brandenburg.de/karte/'
    },
    "test-tourism.reiseland-brandenburg.de": { //www.dahme-seen.de
        root: 2947,
        ajaxRenderPage: 3067,
        resourcesBaseUrl: 'https://static.reiseland-brandenburg.de',//
        mapUrl: 'https://www.reiseland-brandenburg.de/karte/',
        //globalMapUrl: 'https://www.reiseland-brandenburg.de/karte/'
    },
    "dev-fl.reiseland-brandenburg.de": {
        root: 2805,
        ajaxRenderPage: 2923,
        resourcesBaseUrl: 'https://dev-fl.reiseland-brandenburg.de',
        mapUrl: 'www.reiseregion-flaeming.de/karte',
        //globalMapUrl: 'www.reiseregion-flaeming.de/karte',
        region:12,
        regionOnMap: 200
    },
    "www.brandenburg-tourism.com": { //www.dahme-seen.de
        root: 2947,
        ajaxRenderPage: 3067,
        resourcesBaseUrl: 'https://static.reiseland-brandenburg.de',//
        mapUrl: 'https://maps.brandenburg-tourism.com/',
        //globalMapUrl: 'https://maps.brandenburg-tourism.com/'
    },
    "test.brandenburg-tourism.com": { //www.dahme-seen.de
        root: 2947,
        ajaxRenderPage: 3067,
        resourcesBaseUrl: 'https://static.reiseland-brandenburg.de',//
        mapUrl: 'https://maps.brandenburg-tourism.com/',
        apiEndpoint: 'https://api.tmb.pixelpoint.biz/api/',
        //globalMapUrl: 'https://maps.brandenburg-tourism.com/'
    },
    "live-flaeming.reiseland-brandenburg.de": {
        root: 2877,
        ajaxRenderPage: 2886,
        resourcesBaseUrl: 'https://maps-flaeming.reiseland-brandenburg.de/',
        mapUrl: 'https://maps-flaeming.reiseland-brandenburg.de/',
        globalMapUrl: 'https://maps-flaeming.reiseland-brandenburg.de/',
        assetFolder: 'flaeming/',
        region:12,
        regionOnMap: 200
    },
    "www.reiseregion-flaeming.de": {
        root: 2877,
        ajaxRenderPage: 2886,
        resourcesBaseUrl: 'https://www.reiseregion-flaeming.de/karte/',
        mapUrl: 'https://maps.reiseregion-flaeming.de/',
        //globalMapUrl: 'https://wwww.reiseregion-flaeming.de/karte/',
        assetFolder: 'flaeming/',
        region:12,
        regionOnMap: 200
    },
    "test.reiseregion-flaeming.de": {
        root: 2877,
        ajaxRenderPage: 2886,
        resourcesBaseUrl: 'https://www.reiseregion-flaeming.de/karte/',
        mapUrl: 'https://maps.reiseregion-flaeming.de/',
        //globalMapUrl: 'https://wwww.reiseregion-flaeming.de/karte/',
        assetFolder: 'flaeming/',
        region:12,
        regionOnMap: 200,
        apiEndpoint: 'https://api.tmb.pixelpoint.biz/api/'
    },
    "ruppiner-seenland.reiseland-brandenburg.de": {
        root: 4206,
        ajaxRenderPage: 4211,
        resourcesBaseUrl: 'https://static.reiseland-brandenburg.de',
        mapUrl: 'https://maps-ruppiner-seenland.reiseland-brandenburg.de/',
        globalMapUrl: 'https://ruppiner-seenland.reiseland-brandenburg.de/karte/',
        assetFolder: 'ruppiner-seenland/',
        contactPages: {0: '/kontaktformular/', 1:'/en/contact-form/'},
        languagesOnSameDomain: true,
        region:4,
        regionOnMap: 4
    },
    "www.ruppiner-seenland.de": {
        root: 4206,
        ajaxRenderPage: 4211,
        resourcesBaseUrl: 'https://static.reiseland-brandenburg.de',
        mapUrl: 'https://www.ruppiner-seenland.de/karte/',//'https://maps.ruppiner-seenland.de/',
        globalMapUrl: 'https://www.ruppiner-seenland.reiseland.de/karte/',
        assetFolder: 'ruppiner-seenland/',
        contactPages: {0: '/kontaktformular/', 1:'/en/contact-form/'},
        languagesOnSameDomain: true,
        region:4,
        regionOnMap: 4
    },
    "test.ruppiner-seenland.de": {
        root: 4206,
        ajaxRenderPage: 4211,
        resourcesBaseUrl: 'https://static.reiseland-brandenburg.de',
        mapUrl: 'https://www.ruppiner-seenland.de/karte/',//'https://maps.ruppiner-seenland.de/',
        globalMapUrl: 'https://www.ruppiner-seenland.reiseland.de/karte/',
        assetFolder: 'ruppiner-seenland/',
        contactPages: {0: '/kontaktformular/', 1:'/en/contact-form/'},
        languagesOnSameDomain: true,
        region:4,
        regionOnMap: 4,
        apiEndpoint: 'https://api.tmb.pixelpoint.biz/api/'
    },
    "ruppiner-seenland.live.reiseland-brandenburg.de": {
        root: 4206,
        ajaxRenderPage: 4211,
        resourcesBaseUrl: 'https://static.reiseland-brandenburg.de',
        mapUrl: 'https://maps-ruppiner-seenland.reiseland-brandenburg.de/',
        globalMapUrl: 'https://ruppiner-seenland.reiseland-brandenburg.de/karte/',
        assetFolder: 'ruppiner-seenland/',
        contactPages: {0: '/kontaktformular/', 1:'/en/contact-form/'},
        languagesOnSameDomain: true,
        region:4,
        regionOnMap: 4
    },
    "localhost": {
        root: 1,
        ajaxRenderPage: 1568,
        resourcesBaseUrl: 'https://test.reiseland-brandenburg.de',
        apiEndpoint: 'https://api.tmb.pixelpoint.biz/api/',
    },
    "default": {
        root: 1,
        ajaxRenderPage: 1568,
        resourcesBaseUrl: `${window.location.protocol}//${window.location.hostname}:${window.location.port}`,
        mapUrl: document.querySelector('meta[name="ppcarto-root"]')?.content,
        //assetFolder: ''
        assetFolder: 'brandenburg/',
        languagesOnSameDomain: false, //if true all ajax requests will explicitely include the L parameter (language stuff)
        ajaxModuleReloadPrettyUrls:{
          0: 'sys/sys-render-module/',
          1: 'en/sys/sys-render-module/'
        },
        sameDomainAjaxUrls:{
            0: '/index.php',
            1: '/en/'
        },
    apiEndpoint: 'https://api.tmb.pixelpoint.biz/api/'
    }
};

var privateFunctions = {
    get: (key) => {
        if(!!settings[window.location.hostname] && Object.keys(settings[window.location.hostname]).includes(key)/* !!settings[window.location.hostname][key] */){
            return settings[window.location.hostname][key];
        }
        else if(!!settings.default && Object.keys(settings.default).includes(key)){
            return settings.default[key];  
        }
        return null;
    }
}

window.pixelpoint.domainService = {
    get: privateFunctions.get
}